import { KeyboardEvent } from 'react';

/** Keyboard handler that runs `action` on Enter or Space, so a clickable element that is not a button can be used without a mouse. */
export const onActivate = (action: () => void) => (e: KeyboardEvent) => {
  // A button inside the element handles its own keys; only react when the element itself has focus.
  if (e.target !== e.currentTarget) return;
  if (e.key !== 'Enter' && e.key !== ' ') return;
  e.preventDefault();
  action();
};

/** Everything a non-button element needs to act like a button: the role, a tab stop, a click handler and Enter / Space. */
export const activateProps = (action: () => void) => ({
  role: 'button' as const,
  tabIndex: 0,
  onClick: action,
  onKeyDown: onActivate(action),
});
